var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBghomel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 289,
    height: 573,
    viewBox: "0 0 289 573",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 191.571V96H0V191.571H96Z",
    fill: "#91C883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96 287.286V191.714H0V287.286H96Z",
    fill: "#EA6C58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M96 478.428V382.857H0V478.428H96Z",
    fill: "#468E87"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288 96.1432V0.571777L192 0.571777V96.1432H288Z",
    fill: "#FEF9EA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96 290L96 385.571L192 385.571L192 290L96 290Z",
    fill: "#91C883"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M193 194L193 289.571L289 289.571L289 194L193 194Z",
    fill: "#16332F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M192 573V477.428H96V573H192Z",
    fill: "#16332F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192 191.571V96H96V191.571H192Z",
    fill: "#468E87"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBghomel);
export default __webpack_public_path__ + "static/media/bghomel.019669f9bc7c268bd416371cda005d5b.svg";
export { ForwardRef as ReactComponent };